import { createPortal } from 'react-dom';
import { useEffect, useState } from 'react';
import { aws } from '../lib/awsdb';
import { storage } from '../lib/awsStorage';
import { formatMoney } from '../lib/money';

export function parseActivityDetail(notes) {
  if (!notes || !notes.startsWith('detail:')) return null;
  try { return JSON.parse(notes.slice(7)); } catch { return null; }
}

export function activityRefLabel(entry) {
  const d = parseActivityDetail(entry.notes);
  return d?.ref || null;
}

export default function ActivityDetailPopup({ entry, onClose }) {
  const detail = parseActivityDetail(entry.notes);
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    function onKey(e) { if (e.key === 'Escape') onClose(); }
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  async function openFile() {
    const bucket = detail?.proof_bucket || detail?.file_bucket;
    const path = detail?.proof_path || detail?.file_path;
    if (!bucket || !path) return;
    const { data, error } = await storage.from(bucket).createSignedUrl(path, 3600);
    if (!error && data?.signedUrl) window.open(data.signedUrl, '_blank');
  }

  if (!detail) return null;

  const isPayment = entry.action_type === 'payment_logged';
  const isApproval = detail.type === 'approval';
  const ts = new Date(entry.created_at);
  const timeStr = ts.toLocaleString('en-AU', { day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true }).toLowerCase();
  const hasFile = detail.proof_path || detail.file_path;

  return createPortal(
    <>
      <div className="quickpay-backdrop" onClick={onClose} />
      <div className="quickpay-modal activity-detail-popup" role="dialog">
        <div className="adp-header">
          <span className="adp-ref">{detail.ref}</span>
          <button className="file-preview-close" onClick={onClose}>×</button>
        </div>

        <div className="adp-body">
          {isPayment && (
            <>
              <div className="adp-row">
                <span className="adp-label">Paid by</span>
                <span className="adp-value">{entry.actor_name}</span>
              </div>
              <div className="adp-row">
                <span className="adp-label">Amount</span>
                <span className="adp-value adp-money">{formatMoney(detail.amount)}</span>
              </div>
              <div className="adp-row">
                <span className="adp-label">Method</span>
                <span className="adp-value">{detail.method || '—'}</span>
              </div>
              <div className="adp-row">
                <span className="adp-label">Date</span>
                <span className="adp-value">{detail.date || '—'}</span>
              </div>
              <div className="adp-row">
                <span className="adp-label">Logged</span>
                <span className="adp-value">{timeStr}</span>
              </div>
            </>
          )}

          {isApproval && (
            <>
              <div className="adp-row">
                <span className="adp-label">Approved by</span>
                <span className="adp-value">{entry.actor_name}</span>
              </div>
              <div className="adp-row">
                <span className="adp-label">Amount approved</span>
                <span className="adp-value adp-money">{detail.amount ? formatMoney(detail.amount) : '—'}</span>
              </div>
              <div className="adp-row">
                <span className="adp-label">Reason</span>
                <span className="adp-value">{detail.reason || '—'}</span>
              </div>
              <div className="adp-row">
                <span className="adp-label">Approved</span>
                <span className="adp-value">{timeStr}</span>
              </div>
            </>
          )}

          {hasFile && (
            <div className="adp-row">
              <span className="adp-label">Attachment</span>
              <span className="adp-value">
                <button type="button" className="adp-file-link" onClick={openFile}>
                  {detail.proof_file || detail.file || 'View file'}
                  <svg width="14" height="14" viewBox="0 0 16 16" fill="none" style={{ marginLeft: 4, verticalAlign: 'middle' }}><path d="M1 8s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5z" stroke="currentColor" strokeWidth="1.5"/><circle cx="8" cy="8" r="2" stroke="currentColor" strokeWidth="1.5"/></svg>
                </button>
              </span>
            </div>
          )}
        </div>
      </div>
    </>,
    document.body
  );
}
